












import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ChangeRadio extends Vue {
  @Prop() private data: Array<any> | undefined;
  @Prop() private index: number | undefined;

  private butIndex: any = 0;

  private mounted() {
    if (this.index) {
      this.butIndex = this.index;
    }
  }

  private async changeDate(data: any) {
    if (this.butIndex === data) {
      this.butIndex = 0;
    } else {
      this.butIndex = data;
    }
    this.$emit('getCheck', data);
  }

  private responseMethod() {
    this.butIndex = 0;
  }
}
